















































import { PLAN } from "@/resources/constants/plan";
import { i18n } from "@/resources/locales";
import Plans from "@/resources/mixins/plans/plans";
import UserValidator from "@/resources/mixins/userValidator";
import { Component, Mixins } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import NotificationEvent from "../../../../resources/mixins/notifications/notificationEvent";
import SpaceDiarySelectorComponent from "./spaceDiarySelector.component.vue";
@Component({
  name: "event-calendar-component",
  components: {
    VueEditor,
    SpaceDiarySelectorComponent,
  },
})
export default class EventCalendarComponent extends Mixins(
  NotificationEvent,
  UserValidator,
  Plans,
) {
  PLAN = PLAN;
  content = "";
  showSelector = false;
  get active(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenCalendarModal"];
  }
  set active(e) {
    this.$store.dispatch("FloatMenuStore/setOpenCalendarModalAction", e);
  }
  mounted() {
    this.getDiary();
  }
  getDiary() {
    if (!this.activeOptionPlan(PLAN.AGENDA)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/getDiaryAction", {
      superSpaceId: space.superSpace.id,
      callback: (data) => {
        this.content = data.diary;
      },
    });
  }
  saveDiary() {
    if (!this.activeOptionPlan(PLAN.AGENDA)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/updateDiaryAction", {
      superSpaceId: space.superSpace.id,
      data: { diary: this.content },
      callback: () => {
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.calendarUpdate")
        );
      },
    });
  }
}
